const ANCHORS = 'anchors';
const TOOLTIP = 'tooltip';
const BRUSH_ANCHORS = 'brush-anchors';
const PERSISTENT_ANCHORS = 'persistent-anchors';
const FILTER = 'filter';
const HIGHLIGHTER = 'highlighter';
const CROSSLINE = 'crossline';
const FRAGMENTED_TOOLTIP = 'fragmented-tooltip';
const AXIS_LABEL_HIGHLIGHTER = 'axis-label-highlighter';

export {
    ANCHORS,
    BRUSH_ANCHORS,
    PERSISTENT_ANCHORS,
    FILTER,
    HIGHLIGHTER,
    CROSSLINE,
    TOOLTIP,
    FRAGMENTED_TOOLTIP,
    AXIS_LABEL_HIGHLIGHTER
};
